import React, { Component } from 'react';
import NavBar from './components/NavBar';
import { msalConfig, tokenRequest, loginRequest, graphConfig } from './config';
import qs from 'qs';
import {myMSALObj,requestOptions,proxyUrl,tokenUrl,searchRequestOptions,detailsBaseUrl,esbRequestOptions,restrictedEntities,environmentSetUp,environmentSelection} from './components/Configurations'
import { AccessTokenCacheItem } from 'msal/lib-commonjs/cache/AccessTokenCacheItem';
import $ from "jquery";
import Pagination from "react-bootstrap-4-pagination";

let selectedEntity = "";
let selectedClassification = "";
let allAvailableEntities = [];
let allAvailableClassification = [];
let searchScoreMap = {};
let targetEntity = "";

const colorMap = {
    "PUBLIC":"green",
    "CONFIDENTIAL":"orange",
    "STRICTLY CONFIDENTIAL":"red",
    "UNCLASSIFIED":"grey"
  }
const colorMap2 = {
"YES":"#F2635C",
"NO":"#1BA397"
}
const colorMap3 = {
"SAP":"#006699",
"EXCEL":"#006600",
"HTML":"#cc6600"
}

class SearchResults extends Component {

    constructor(props){
        super(props);
        // console.log(props)
        this.state = {
            keyword:"",
            results:[],
            totalResults:0,
            guid:"",
            accessToken:sessionStorage.getItem('accessToken'),
            expiresOn:sessionStorage.getItem('expiresOn'),
            guidList:[],
            detailedResults:[],
            newDetailedResults:[],
            selectedResults:[],
            availableEntities:[],
            availableClassification:[],
            selectedEntity:"",
            selectedClassification:"",
            selectedPublic:false,
            selectedUnclassified:false,
            selectedConfidential:false,
            selectedStrictlyConfidential:false,
            currentPage:1,
            suggestedAsset:[],
            typed:"",
            searchFilters:[{"assetType": "Data Catalog"}],
            PaginationItemsPerPage: 10,
            PaginationCurrentPage: 1,
            PaginationTotalPages: 1,
            NumberOfRecords:-1,
        }
        this.handleLogOut = this.handleLogOut.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleSelectEntity = this.handleSelectEntity.bind(this);
        this.handleClearFilter = this.handleClearFilter.bind(this);
        this.handleChangeClassification = this.handleChangeClassification.bind(this);
        this.updateAvailableClassification = this.updateAvailableClassification.bind(this);
        this.updateAvailableEntities = this.updateAvailableEntities.bind(this);
        this.handleCreate = this.handleCreate.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleClickSuggestion = this.handleClickSuggestion.bind(this)
    }

    handleCreate(){
        this.props.history.push({
            pathname:'/create'
        })
    }

    handleClick(event){
        this.setState({guid:event.target.id},()=>{
            this.props.history.push({
                pathname:'/details',
                search:"guid="+this.state.guid,
                state:{
                    guid:this.state.guid,
                    keyword:this.state.keyword
                },
            })
        });
    };

    handleLogOut(){
        sessionStorage.setItem('user','');
        sessionStorage.setItem('email','');
        sessionStorage.setItem('keyword','');
        sessionStorage.setItem('accessToken','');
        sessionStorage.setItem('expiresOn','');
        sessionStorage.setItem('role','');
        this.props.history.push('/logout');
        myMSALObj.logout();
      }
    
    handleSelectEntity(event){
        var data = this.state.detailedResults;
        var selectedClassificationValue = this.state.selectedClassification;

        selectedEntity = event.target.value
        if(selectedEntity==='default'){

            if(selectedClassificationValue !== ''){


                this.setState({
                    newDetailedResults: data.filter(function(item){
                        return item['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level'] === selectedClassificationValue
                    }),
                    NumberOfRecords:data.filter(function(item){
                        return item['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level'] === selectedClassificationValue
                    }).length,
                    selectedEntity: selectedEntity
                },()=>{
                    this.updateAvailableClassification();
                    this.updateAvailableEntities();
                }) 


            }else{
                this.setState({
                    newDetailedResults: data,
                    NumberOfRecords:data.length,
                    selectedEntity: selectedEntity
                },()=>{
                    this.updateAvailableClassification();
                    this.updateAvailableEntities();
                }) 

            }

            


        }else{

            if(selectedClassificationValue !== ''){

                this.setState({
                    newDetailedResults: data.filter(function(item){
                        return item['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID'] === event.target.value && item['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level'] === selectedClassificationValue
                    }),
                    NumberOfRecords:data.filter(function(item){
                        return item['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID'] === event.target.value && item['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level'] === selectedClassificationValue
                    }).length,
                    selectedEntity: selectedEntity
                },()=>{
                    this.updateAvailableClassification();
                    this.updateAvailableEntities();
                }) 
        


            }else{
                this.setState({
                    newDetailedResults: data.filter(function(item){
                        return item['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID'] === event.target.value
                    }),
                    NumberOfRecords:data.filter(function(item){
                        return item['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID'] === event.target.value
                    }).length,
                    selectedEntity: selectedEntity
                },()=>{
                    this.updateAvailableClassification();
                    this.updateAvailableEntities();
                }) 
        
            }


      







    }
        //  this.setState({
        //     NumberOfRecords:this.state.newDetailedResults.length
        // });
}

    handleChangeClassification(event){
        var data = this.state.detailedResults;

        selectedClassification = event.target.value

    this.setState({
        selectedClassification:selectedClassification
            });

        switch (selectedClassification){
            case "PUBLIC": this.setState({
                selectedPublic:true,
                selectedUnclassified:false,
                selectedConfidential:false,
                selectedStrictlyConfidential:false
            }); break;
            case "UNCLASSIFIED": this.setState({
                selectedPublic:false,
                selectedUnclassified:true,
                selectedConfidential:false,
                selectedStrictlyConfidential:false
            }); break;
            case "CONFIDENTIAL": this.setState({
                selectedPublic:false,
                selectedUnclassified:false,
                selectedConfidential:true,
                selectedStrictlyConfidential:false
            }); break;
            case "STRICTLY CONFIDENTIAL": this.setState({
                selectedPublic:false,
                selectedUnclassified:false,
                selectedConfidential:false,
                selectedStrictlyConfidential:true
            }); break;
        }

        var selctedEntityValue= this.state.selectedEntity;
        if(selctedEntityValue !=='default' && selctedEntityValue !==''){
            this.setState({
                newDetailedResults: data.filter(function(item){
                    return item['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level'] === event.target.value && item['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID'] === selctedEntityValue
                }),
                NumberOfRecords:data.filter(function(item){
                    return item['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level'] === event.target.value && item['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID'] === selctedEntityValue
                }).length
            },()=>{
                
                this.updateAvailableEntities();
                this.updateAvailableClassification();
            })
        }else{
            this.setState({
                newDetailedResults: data.filter(function(item){
                    return item['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level'] === event.target.value
                }),
                NumberOfRecords:data.filter(function(item){
                    return item['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level'] === event.target.value
                }).length
            },()=>{
                
                this.updateAvailableEntities();
                this.updateAvailableClassification();
            })
        }


       
    }

    updateAvailableEntities(){
        console.log("trying to update entity with")
        // this.setState({
        //     availableEntities:allAvailableEntities.filter(function(item){
        //         return item === selectedEntity
        //     })
        // })
    }

    updateAvailableClassification(){
        console.log("trying to update classification")
        // let tempList = []
        // this.state.selectedResults.map(item=>{
        //     if(!tempList.includes(item.attributes.Sensitivity_Level)){
        //         tempList.push(item.attributes.Sensitivity_Level)
        //     }
        // },()=>{
        //     console.log(tempList)
        //     this.setState({
        //         availableClassification:tempList
        //     })
        // })
    }

    handleClearFilter(){
        var data = this.state.detailedResults;
        this.setState({
            selectedResults:this.state.newDetailedResults,
            availableClassification:allAvailableClassification,
            availableEntities:allAvailableEntities,
            selectedPublic:false,
            selectedUnclassified:false,
            selectedConfidential:false,
            selectedStrictlyConfidential:false,
            selectedClassification:"",
            selectedEntity:"",
            newDetailedResults: data,
            NumberOfRecords:data.length

        });

        // window.location.reload(false)
        $("#entityDropdown").val("default")

    }

    async handleSubmit(event) {
        let currentTime = new Date().getTime()/1000;
        if (sessionStorage.getItem('accessToken') === null || sessionStorage.getItem('expiresOn')-18000<=currentTime+60 || sessionStorage.getItem('accessToken') === "undefined"){
            console.log('token is bad.')
            // const res = await fetch(proxyUrl+tokenUrl,requestOptions);
            // const res = await fetch("https://data-catalog-token-server.azurewebsites.net/api/getToken")
            const res = await fetch(environmentSetUp['purviewAccessToken'][environmentSelection])
            const data = await res.json();
            var currentDateTime = new Date();
            console.log('the new code');
            currentDateTime.setSeconds(currentDateTime.getSeconds() + data.expires_in);
            this.setState({
                accessToken:data.access_token,
                expiresOn:new Date(currentDateTime).getTime()/1000
                // accessToken:data.accessToken,
                // expiresOn:new Date(data["expiresOn"]).getTime()/1000
            },()=>{
                    sessionStorage.setItem('accessToken',this.state.accessToken);
                    sessionStorage.setItem('expiresOn',this.state.expiresOn);
                    this.props.history.push({
                        pathname:'/results?keyword='+this.state.typed,
                      //   search:"keyword="+this.state.keyword,
                        state:{
                          keyword:this.state.typed,
                          accessToken:this.state.accessToken,
                          expiresOn:this.state.expiresOn
                        }
                    })
                    event.preventDefault();
                    window.location.reload();
                })
        }else{
            console.log('token is good.')
            this.props.history.push({
                pathname:'/results?keyword='+this.state.typed,
              //   search:"keyword="+this.state.keyword,
                state:{
                  keyword:this.state.typed,
                  accessToken:this.state.accessToken,
                  expiresOn:this.state.expiresOn
                }
            })
            event.preventDefault();
            window.location.reload();
        }        
        
      };
    
      handleChange(event) {

        var count= 0;
        if(this.state.newDetailedResults.length > 0 && event.target.value.length > 0){
            var data = this.state.newDetailedResults;
            for(var i=0;i<data.length;i++){
                //record.attributes.name
                if(data[i].attributes.name !== undefined && data[i].attributes.name?.toLowerCase().includes(event.target.value.toLowerCase())){
                    count ++;
                }
            }
        }else{
            if(count === 0){
                count = this.state.newDetailedResults.length;
            }
        }
        this.setState({
            typed: event.target.value,
            NumberOfRecords:count
        });

        // this.setState({
        //   typed: event.target.value,
        // //   keyword:event.target.value
        // },()=>{
        //   if(this.state.typed!==""){
        //     let currentTime = new Date().getTime()/1000
        //     if (sessionStorage.getItem('accessToken') === null || sessionStorage.getItem('expiresOn')-18000<=currentTime+60 || sessionStorage.getItem('accessToken') === "undefined"){
        //       console.log('token is bad');
        //       var currentDateTime = new Date();
        //     //   fetch(proxyUrl + tokenUrl,requestOptions)
        //     //   fetch("https://data-catalog-token-server.azurewebsites.net/api/getToken")
        //     fetch(environmentSetUp['purviewAccessToken'][environmentSelection])
        //       .then(res=>res.json()).then(data=>this.setState({
        //         accessToken:data.access_token,
        //         expiresOn:new Date(currentDateTime.setSeconds(currentDateTime.getSeconds() + data.expires_in)).getTime()/1000
        //         // accessToken:data.accessToken,
        //         // expiresOn:new Date(data["expiresOn"]).getTime()/1000
        //       },()=>{
        //         sessionStorage.setItem('accessToken',this.state.accessToken);
        //         sessionStorage.setItem('expiresOn',this.state.expiresOn);
        //         // fetch("https://sys-purview.catalog.purview.azure.com/api/atlas/v2/search/suggest",{
        //         fetch(environmentSetUp["searchSuggestUrl"][environmentSelection],{
        //           method:"POST",
        //           headers:{
        //               'Authorization':'Bearer ' + sessionStorage.getItem('accessToken'),
        //               'Content-Type': 'application/json'
        //           },
        //           body: JSON.stringify({
        //             keywords:this.state.typed,
        //             filter:{
        //               or:[
        //                 {"assetType": "UN_Manual_Input"}
        //               ]
        //             },
        //             limit:10
        //           })
        //         }).then(res=>JSON.stringify(res)).then(data=>this.setState({suggestedAsset:data}))
        //       }))
        //     }else{
        //       console.log('token is good');
        //     //   fetch("https://sys-purview.catalog.purview.azure.com/api/atlas/v2/search/suggest",{
        //     fetch(environmentSetUp["searchSuggestUrl"][environmentSelection],{
        //         method:"POST",
        //         headers:{
        //             'Authorization':'Bearer ' + sessionStorage.getItem('accessToken'),
        //             'Content-Type': 'application/json'
        //         },
        //         body: JSON.stringify({
        //           keywords:this.state.typed,
        //           filter:{
        //             or:[
        //                 {"assetType": "UN_Manual_Input"}
        //             ]
        //           },
        //           limit:10
        //         })
        //     }).then(res=>JSON.stringify(res)).then(data=>this.setState({suggestedAsset:data}))
        //     }
        //   }
        // })
      };

    handleClickSuggestion(event){
    // console.log("clicked something")
    this.setState({guid:event.target.id},()=>{
        this.props.history.push({
            pathname:'/details',
            search:"guid="+this.state.guid,
            state:{guid:this.state.guid}
        })
    });
    }

    // handleSubmitFilter(){
    //     this.props.history.push({
    //         pathname:'/results',
    //         search:"keyword="+this.state.keyword+(this.state.selectedEntity===""?"":"&entity="+this.state.selectedEntity)+(this.state.selectedClassification===""?"":"&classification="+this.state.selectedClassification),
    //         state:{guid:this.state.guid}
    //     })
    // }

    componentWillMount(){
        
        if(qs.parse(this.props.location.search)['?keyword'] !== undefined){
            // console.log("found param")
            this.setState({
                keyword:qs.parse(this.props.location.search)['?keyword']
            },()=>{
                // console.log("state set")
                sessionStorage.setItem('keyword',this.state.keyword)
            })
        }else{
            sessionStorage.setItem('keyword',this.state.keyword)
        }

        if(qs.parse(this.props.location.search)['entity'] !== undefined){
            targetEntity=qs.parse(this.props.location.search)['entity']
        }

    }

    async componentDidMount(){

        function removeItemOnce(arr, value) {
            var index = arr.indexOf(value);
            if (index > -1) {
              arr.splice(index, 1);
            }
            return arr;
          }; 
      
        var restrictedEntitiesDuplicate = restrictedEntities;

        if (myMSALObj.getAccount() === null){
            myMSALObj.loginRedirect(loginRequest);
          }else{
            sessionStorage.setItem('user',myMSALObj.getAccount().name);
            sessionStorage.setItem('email',myMSALObj.getAccount().userName);
            fetch("https://data-catalog-token-server-dev-v2.azurewebsites.net/api/entityLookUpNew?email="+myMSALObj.getAccount().userName).then(res=>res.json()).then(data=>sessionStorage.setItem('userEntity',data.entity)).then(
            removeItemOnce(restrictedEntitiesDuplicate,sessionStorage.getItem('userEntity'))
        ).then(restrictedEntitiesDuplicate.map(item=>{
            this.state.searchFilters.push({
            "not":{
                "attributeName": "Entity_ID",
                "operator": "eq",
                "attributeValue": item
            }
            })
        }))
        }

        let currentTime = new Date().getTime()/1000;
        if (sessionStorage.getItem('accessToken') === null || sessionStorage.getItem('expiresOn')-18000<=currentTime+60 || sessionStorage.getItem('accessToken') === "undefined"){
            // console.log('token is bad.')
            // const res = await fetch(proxyUrl+tokenUrl,requestOptions);
            // const res = await fetch("https://data-catalog-token-server.azurewebsites.net/api/getToken")
            const res = await fetch(environmentSetUp['purviewAccessToken'][environmentSelection])
            const data = await res.json();
            var currentDateTime = new Date();
            currentDateTime.setSeconds(currentDateTime.getSeconds() + data.expires_in);
            this.setState({
                accessToken:data.access_token,
                expiresOn:new Date(currentDateTime).getTime()/1000
                // accessToken:data.accessToken,
                // expiresOn:new Date(data["expiresOn"]).getTime()/1000
            },()=>{
                sessionStorage.setItem('accessToken',this.state.accessToken);
                sessionStorage.setItem('expiresOn',this.state.expiresOn);
                //without any special
                // fetch("https://sys-purview.catalog.purview.azure.com/api/atlas/v2/search/advanced",{
                fetch(environmentSetUp['advancedSearchUrl'][environmentSelection],{
                method: 'POST',
                headers:{
                    'Authorization':'Bearer ' + this.state.accessToken,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    keywords:this.state.keyword,
                    filter:{
                        or:this.state.searchFilters
                    },
                    limit:500
                })
                }).then(res=>res.json())
                .then(data=>{
                    data.value.map(item=>{
                        let tempID = item.id
                        let tempScore = item["@search.score"]
                        searchScoreMap[tempID] = tempScore
                    });
                    this.setState({
                    results:data,
                    totalResults:data['@search.count'],
                },()=>{
                    this.state.results.value.map(item=>{
                        fetch(environmentSetUp["detailBaseUrl"][environmentSelection]+item.id,{
                                        method: 'GET',
                                        headers:{
                                            'Authorization':'Bearer ' + this.state.accessToken,
                                            'Content-Type': 'application/json'
                                        }}).then(res=>res.json()).then(data=>{
                                            if(targetEntity!==""){
                                                this.setState(prevState=>{


                                                    if(data.entity['businessAttributes'] !== undefined && data.entity['businessAttributes']['Metadata Applicable For Data Catalog'] !== undefined){
                                                        data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID']===targetEntity?prevState.detailedResults.push(data.entity):console.log("");
                                                        this.setState({availableEntities:[targetEntity]})
                                                        allAvailableEntities=[targetEntity]
                                                        // if(data.entity['businessAttributes']['Metadata Applicable For Data Catalog'] !== undefined){
                                                        if(data.entity['businessAttributes'] !== undefined && data.entity['businessAttributes']['Metadata Applicable For Data Catalog'] !== undefined && !this.state.availableClassification.includes(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level'])&&data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID']===targetEntity){
                                                            this.state.availableClassification.push(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level'])
                                                        }
                                                        if(data.entity['businessAttributes'] !== undefined && data.entity['businessAttributes']['Metadata Applicable For Data Catalog'] !== undefined && !allAvailableClassification.includes(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level'])&&data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID']===targetEntity){
                                                            allAvailableClassification.push(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level'])
                                                        }
                                                    } 

                                                    

                                                // }


                                                },()=>this.setState({
                                                    newDetailedResults:this.state.detailedResults,
                                                    selectedResults:this.state.detailedResults,
                                                    NumberOfRecords: this.state.detailedResults.length
                                                }))
                                            }else{
                                                this.setState(prevState=>{

                                                    if(data.entity['businessAttributes'] !== undefined && data.entity['businessAttributes']['Metadata Applicable For Data Catalog'] !== undefined){

                                                    prevState.detailedResults.push(data.entity);

                                                    // if(data.entity['businessAttributes']['Metadata Applicable For Data Catalog'] !== undefined){
                                                        if(data.entity['businessAttributes'] !== undefined && data.entity['businessAttributes']['Metadata Applicable For Data Catalog'] !== undefined && !this.state.availableEntities.includes(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID'])){
                                                            this.state.availableEntities.push(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID'])
                                                        }
                                                        if(data.entity['businessAttributes'] !== undefined && data.entity['businessAttributes']['Metadata Applicable For Data Catalog'] !== undefined && !allAvailableEntities.includes(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID'])){
                                                            allAvailableEntities.push(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID'])
                                                        }
                                                        if(data.entity['businessAttributes'] !== undefined && data.entity['businessAttributes']['Metadata Applicable For Data Catalog'] !== undefined && !this.state.availableClassification.includes(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level'])){
                                                            this.state.availableClassification.push(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level'])
                                                        }
                                                        if(data.entity['businessAttributes'] !== undefined && data.entity['businessAttributes']['Metadata Applicable For Data Catalog'] !== undefined && !allAvailableClassification.includes(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level'])){
                                                            allAvailableClassification.push(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level'])
                                                        }
                                                     }
                                                   
                                                },()=>this.setState({
                                                    newDetailedResults:this.state.detailedResults,
                                                    selectedResults:this.state.detailedResults,
                                                    NumberOfRecords: this.state.detailedResults.length
                                                }))
                                            }
                                            
                                        })
                    })
                })})
            })
        }else{
            // console.log('token is good.')
            // const response = await fetch("https://sys-purview.catalog.purview.azure.com/api/atlas/v2/search/advanced",{
            const response = await fetch(environmentSetUp["advancedSearchUrl"][environmentSelection],{
                method: 'POST',
                headers:{
                    'Authorization':'Bearer ' + sessionStorage.getItem('accessToken'),
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    keywords:this.state.keyword,
                    filter:{
                        or:this.state.searchFilters
                    },
                    limit:500
                })
                })
            const data = await response.json();
            // console.log(data)
            data.value.map(item=>{
                let tempID = item.id
                let tempScore = item["@search.score"]
                searchScoreMap[tempID] = tempScore
            });
            this.setState({
                results:data,
                totalResults:data['@search.count']},()=>{

                    this.state.results.value.map(item=>{
                        // fetch(detailsBaseUrl+item.id,{
                        fetch(environmentSetUp["detailBaseUrl"][environmentSelection]+item.id,{
                                        method: 'GET',
                                        headers:{
                                            'Authorization':'Bearer ' + this.state.accessToken,
                                            'Content-Type': 'application/json'
                                        }}).then(res=>res.json()).then(data=>{
                                            if(targetEntity!==""){
                                                this.setState(prevState=>{



                                                    if(data.entity['businessAttributes'] !== undefined && data.entity['businessAttributes']['Metadata Applicable For Data Catalog'] !== undefined){
                                                    data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID']===targetEntity?prevState.detailedResults.push(data.entity):console.log("");
                                                    this.setState({availableEntities:[targetEntity]})
                                                    allAvailableEntities=[targetEntity]
                                                    // if(data.entity['businessAttributes']['Metadata Applicable For Data Catalog'] !== undefined){


                                                    if(data.entity['businessAttributes'] !== undefined && data.entity['businessAttributes']['Metadata Applicable For Data Catalog'] !== undefined && !this.state.availableClassification.includes(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level'])&&data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID']===targetEntity){
                                                        this.state.availableClassification.push(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level'])
                                                    }
                                                    if(data.entity['businessAttributes'] !== undefined && data.entity['businessAttributes']['Metadata Applicable For Data Catalog'] !== undefined && !allAvailableClassification.includes(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level'])&&data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID']===targetEntity){
                                                        allAvailableClassification.push(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level'])
                                                    }
                                                 }
                                                },()=>this.setState({
                                                    newDetailedResults:this.state.detailedResults,
                                                    selectedResults:this.state.detailedResults,
                                                    NumberOfRecords: this.state.detailedResults.length
                                                }))
                                            }else{
                                                this.setState(prevState=>{

                                                    if(data.entity['businessAttributes'] !== undefined && data.entity['businessAttributes']['Metadata Applicable For Data Catalog'] !== undefined){
                                                    prevState.detailedResults.push(data.entity);

                                                    // if(data.entity['businessAttributes']['Metadata Applicable For Data Catalog'] !== undefined){
                                                    if(data.entity['businessAttributes'] !== undefined && data.entity['businessAttributes']['Metadata Applicable For Data Catalog'] !== undefined && !this.state.availableEntities.includes(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID'])){
                                                        this.state.availableEntities.push(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID'])
                                                    }
                                                    if(data.entity['businessAttributes'] !== undefined && data.entity['businessAttributes']['Metadata Applicable For Data Catalog'] !== undefined && !allAvailableEntities.includes(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID'])){
                                                        allAvailableEntities.push(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID'])
                                                    }
                                                    if(data.entity['businessAttributes'] !== undefined && data.entity['businessAttributes']['Metadata Applicable For Data Catalog'] !== undefined && !this.state.availableClassification.includes(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level'])){
                                                        this.state.availableClassification.push(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level'])
                                                    }
                                                    if(data.entity['businessAttributes'] !== undefined && data.entity['businessAttributes']['Metadata Applicable For Data Catalog'] !== undefined && !allAvailableClassification.includes(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level'])){
                                                        allAvailableClassification.push(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level'])
                                                    }

                                                }
                                                },()=>this.setState({
                                                    newDetailedResults:this.state.detailedResults,
                                                    selectedResults:this.state.detailedResults,
                                                    NumberOfRecords: this.state.detailedResults.length
                                                }))
                                            }
                                            
                                        })
                    })
                })
        }

        // $("#searchBarInput").focus(function(){
        //     $("#suggestionDropDown").show();
        //   })
      
        //   $("#searchBarInput").blur(function(){
        //     let timer;
        //     timer = setTimeout(function(){
        //       $("#suggestionDropDown").hide();
        //     },120);
        //   })
    }
    render(){
        // console.log(this.state)
        if(this.state.results.value===undefined){
            return (
                <div className="spinner text-center ">
                    <div className="spinner-border align-middle" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            )
        }
        else{
            let selectedResultsForDisplay = this.state.selectedResults.sort((a,b)=>{
                if(searchScoreMap[a.guid]>searchScoreMap[b.guid]){
                    return -1
                }else{
                    return 1
                }
            })
            let currentInstance = this
            // console.log(selectedResultsForDisplay.length)
        return(
            
            <React.Fragment>
                <NavBar handleLogOut={this.handleLogOut}  handleCreate={this.handleCreate}/>
                
                <div className="search-results-main">

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb-content breadcrumb bg-light w-100 mr-0 float-left">
                            <li className="breadcrumb-item small"><a href="/">Home</a></li>
                            <li className="breadcrumb-item active small">List</li>
                        </ol>
                    </nav>
                    
                    <div className="container-fluid row results-main mx-0">
                        <div className="col-8">
                        <form  className="input-group search-bar mb-3">
                            <input id="searchBarInput" type="text" className="form-control" value={this.state.typed} onChange={this.handleChange} autoComplete="off" placeholder="For example, development, travel, etc." />
                        </form>
                        <div className="breadcrumb-badge breadcrumb bg-light w-100">
                            <div className="text-left w-100">
                                <p className="text-secondary">{this.state.NumberOfRecords === -1 ? this.state.newDetailedResults.length  : this.state.NumberOfRecords} result(s) shown for the keyword <strong>"{this.state.typed}"</strong></p>  
                            </div> 
                        </div>

                        {this.state.detailedResults.map(
                            (record, inx) => {
                                if ((this.state.typed.length <= 1 && this.state.newDetailedResults.slice((this.state.PaginationCurrentPage - 1) * this.state.PaginationItemsPerPage, this.state.PaginationCurrentPage * this.state.PaginationItemsPerPage).includes(record)) || (this.state.typed.length > 1 && record['businessAttributes']['Metadata Applicable For Data Catalog']['Name']?.toLowerCase().includes(this.state.typed.toLowerCase()))) {

                                    
                                    return(
                                        <div key={record.guid} onClick={this.handleClick} className="card shadow-sm mb-4" id={record.guid}>
                                            <div className="card-body search-results pb-0">
                                                <h5 className="card-title font-weight-bold float-left w-75 mx-0 mb-0 search-results">
                                                    {record['businessAttributes']['Metadata Applicable For Data Catalog']['Name']}
                                                </h5>
                                                <p className="card-subtitle w-25 float-right text-right mt-0 search-results font-weight-bold">
                                                    {record['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID'] + " - " + record['businessAttributes']['Metadata Applicable For Data Catalog']['Organization']}
                                                </p>   
                                            </div>
    
                                            <div className="card-body w-100 text-left text-secondary search-results pb-0">
                                                <p>
                                                    {record['businessAttributes']['Metadata Applicable For Data Catalog']['Description']===""?"No description available":record['businessAttributes']['Metadata Applicable For Data Catalog']['Description']}
                                                </p>                                    
                                            </div>
                                            <div className="card-body w-100 text-left text-secondary search-results py-0 mb-1 form-inline" >
                                                <i className="fas fa-circle" style={{color: colorMap[record['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level']]}}></i>
                                                <p className="pt-3 pl-2 font-weight-bold" >{record['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level']}</p>
                                                <span className="px-3" >&#124;</span>
                                                <i className={record['businessAttributes']['Metadata Applicable For Data Catalog']['PII']==="YES"?"far fa-eye":"far fa-eye-slash"} style={{color:colorMap2[record['businessAttributes']['Metadata Applicable For Data Catalog']['PII']]}} ></i>
                                                <p className="pt-3 pl-2 font-weight-bold">PII: {record['businessAttributes']['Metadata Applicable For Data Catalog']['PII']}</p>
                                                <span className="px-3" >&#124;</span>
                                                <i className={record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']==="HTML"?"far fa-file-code":record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']==="EXCEL"?"fas fa-table":record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']==="SAP"?"fas fa-database":"fas fa-question"} style={{color:colorMap3[record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']]}} />
                                                <p className="pt-3 pl-2 font-weight-bold">Back End: {record.attributes.Database_Management_System}</p>
                                            </div>     
                                        </div>
                                    )
                                }
                            }
                        )}

                        <Pagination
                            threeDots
                            totalPages={this.state.newDetailedResults.length===0?1:Math.ceil(this.state.newDetailedResults.length/10)}
                            currentPage={this.state.PaginationCurrentPage}
                            showMax={15}
                            prevNext={true}
                            color={"rgba(27, 163, 151, 0.75)"}
                            disabledBgColor="#f2f2f2"
                            disabledBorderColor="#f2f2f2"
                            disabeldColor="#e6e6e6"
                            prevText="Previous"
                            nextText="Next"
                            activeBgColor="#344A5A"
                            activeBorderColor="#344A5A"
                            onClick={function(page){
                                currentInstance.setState({PaginationCurrentPage:page})
                            }}
                        />
                        {/* <nav aria-label="Page navigation example">
                            <ul className="pagination pagination-sm">
                                <li className="page-item"><a className="page-link" href="#">Previous</a></li>
                                <li className="page-item"><a className="page-link" href="#">1</a></li>
                                <li className="page-item"><a className="page-link" href="#">2</a></li>
                                <li className="page-item"><a className="page-link" href="#">3</a></li>
                                <li className="page-item"><a className="page-link" href="#">Next</a></li>
                            </ul>
                        </nav> */}
                            
                            
                        </div>
                        <div className="col-4">
                            <div className="card shadow-sm">
                                <div className="card-body">
                                    <h6 className="card-title pb-2 text-uppercase font-weight-bold">
                                        Refine search
                                    </h6>
                                    <div className="border p-3 mb-3">
                                        <p className="font-weight-bold text-secondary">
                                            Filter by Entity
                                        </p>
                                        <select id="entityDropdown" className="custom-select custom-select-sm mb-4" onChange={this.handleSelectEntity} >
                                            <option defaultValue value="default"> -- Select an entity -- </option>
                                            {this.state.availableEntities.map(item=>{
                                                return (<option key={item.toString()} value={item}>{item}</option>)
                                            })}

                                        </select>
                                    </div>
                                    {/* <form onChange={this.handleChangeClassification} className="border p-3 mb-3">
                                        <p className="font-weight-bold text-secondary">
                                            Filter by Sensitivity Level
                                        </p>
                                        <div className="custom-control custom-radio mb-2">
                                            <input type="radio" id="customRadio4" name="customRadio" 
                                                    className="custom-control-input" value="PUBLIC"
                                                    disabled={this.state.availableClassification.includes("PUBLIC")?false:true}
                                                    checked={this.state.selectedPublic} />
                                            <label className="custom-control-label" htmlFor="customRadio4">PUBLIC</label>
                                        </div>
                                        <div className="custom-control custom-radio mb-2">
                                            <input type="radio" id="customRadio1" name="customRadio" 
                                                    className="custom-control-input" value="NOT CLASSIFIED" 
                                                    disabled={this.state.availableClassification.includes("NOT CLASSIFIED")?false:true}
                                                    checked={this.state.selectedUnclassified} />
                                            <label className="custom-control-label" htmlFor="customRadio1">NOT CLASSIFIED</label>
                                        </div>
                                        <div className="custom-control custom-radio mb-2">
                                            <input type="radio" id="customRadio2" name="customRadio" 
                                                    className="custom-control-input" value="CONFIDENTIAL"
                                                    disabled={this.state.availableClassification.includes("CONFIDENTIAL")?false:true}
                                                    checked={this.state.selectedConfidential} />
                                            <label className="custom-control-label" htmlFor="customRadio2">CONFIDENTIAL</label>
                                        </div>
                                        <div className="custom-control custom-radio mb-2">
                                            <input type="radio" id="customRadio3" name="customRadio" 
                                                    className="custom-control-input" value="STRICTLY CONFIDENTIAL"
                                                    disabled={this.state.availableClassification.includes("STRICTLY CONFIDENTIAL")?false:true}
                                                    checked={this.state.selectedStrictlyConfidential} />
                                            <label className="custom-control-label" htmlFor="customRadio3">STRICTLY CONFIDENTIAL</label>
                                        </div>
                                    </form> */}

                                    <form className="border p-3 mb-3">
                                        <p className="font-weight-bold text-secondary">
                                            Filter by Sensitivity Level
                                        </p>
                                        { this.state.availableClassification.map((data) => {

                                            return   ( <div key={data} className="custom-control custom-radio mb-2">
                                                <input  type="radio" id={data} name="customRadio" 
                                                        className="custom-control-input" value={data} onChange={this.handleChangeClassification}
                                                        checked={this.state.selectedClassification === data} />
                                                <label className="custom-control-label" htmlFor={data}>{data}</label>
                                                </div>)
                                                })
                                        }

                                    </form>









                                    {/* <div className="border p-3 mb-3">
                                        <p className="font-weight-bold text-secondary">
                                            Filter by Date
                                        </p>
                                        <form>
                                        <div className="form-group">
                                            <label className="small">FROM</label>
                                            <input type="text" className="form-control form-control-sm" id="formGroupExampleInput" placeholder="DD/MM/YYYY"/>
                                        </div>
                                        <div className="form-group">
                                            <label className="small">TO</label>
                                            <input type="text" className="form-control form-control-sm" id="formGroupExampleInput2" placeholder="DD/MM/YYYY"/>
                                        </div>
                                        </form>         
                                    </div>   */}
                                    {/* <button type="button"
                                    className="btn btn-info btn-sm float-right mr-2"
                                    onClick={this.handleSubmitFilter} >Apply</button> */}
                                    {/* <button type="button" 
                                    className="btn btn-info btn-sm float-right mr-2"
                                    style={{visibility:(this.state.detailedResults.length===this.state.selectedResults.length?"hidden":"visible")}}
                                    onClick={this.handleClearFilter} >Clear Filters</button> */}

                                    <button type="button" style={{visibility:( (this.state.selectedEntity !== "" && this.state.selectedEntity !== "default") || (this.state.selectedClassification !== "") ? "visible" :"hidden")}}
                                     className="btn btn-info btn-sm float-right mr-2" onClick={this.handleClearFilter} >Clear Filters</button>
                                    
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </React.Fragment>
            )
        }
        
    }
}

export default SearchResults;